import React from "react";
import PropTypes from "prop-types";

const Grid = ({ children, gap }) => {
  const gridClass = "m-three-column-grid";
  const gridGapClass = gap
    ? `${gridClass}--gap-${gap}`
    : `${gridClass}--gap-narrow`;

  return <div className={`${gridClass} ${gridGapClass}`}>{children}</div>;
};

Grid.propTypes = {
  children: PropTypes.node,
  gap: PropTypes.string,
};

export default Grid;
